import React, { createContext, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Spinner from 'components/spinner/Spinner';
import { getUserProfile } from 'api/user';
import { toast } from 'react-toastify';

const defaultValue = {
  user: { id: '', email: '', is_active: false, predictions_access: false },
  isLoading: true,
};

const PredictionsEngineContext = createContext(defaultValue);

const PredictionsEngineProvider = ({ children }) => {
  const history = useHistory();

  const [user, setUser] = useState(defaultValue.user);
  const [isLoading, setIsLoading] = useState(defaultValue.isLoading);

  const getProfile = async () => {
    const { data, error: getUserProfileError } = await getUserProfile();

    if (getUserProfileError) {
      toast.error(getUserProfileError.message);
      return;
    }

    setUser({ ...data, predictions_access: true }); // TODO: delete predictions_access

    setIsLoading(false);
  };

  useEffect(() => {
    getProfile();
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  if (!user?.predictions_access) {
    history.push('/');

    return null;
  }

  return (
    <PredictionsEngineContext.Provider value={{ user }}>
      {children}
    </PredictionsEngineContext.Provider>
  );
};

export const usePredictionsEngine = () => useContext(PredictionsEngineContext);

PredictionsEngineProvider.propTypes = { children: PropTypes.any };

export default PredictionsEngineProvider;
